import React from 'react';
import { connect } from 'react-redux';

//Actions
import { novoatualiza, subitemzeraselecionado, zeranovoatualiza } from '../../../../actions/produto/subitem';

//Components
import FormCadastro from '../../../../containers/forms/automacao/FormCadastro';

//Utils
import { getCamposInitialValues, getPreImagesCampo } from '../../../../components/forms/utils/toolsforms';
import { getEvento } from '../../../../utils/eventosession';

class FormProdutos extends React.Component {

    state = {
        camposcomtraducao: false
    }

    handleSubmit = async (form) => {    
        const evento = getEvento();    
        const dados = {
            ...form,
            iditems: this.props.itemevento[0].iditems,
            idsubitems: this.props.item?this.props.item.idsubitems:0,
            idpromotora: evento.idpromotora
        }
        await this.props.novoatualiza(dados);
    }

    handleValidacao = (values) => {

        let errors = {};
                
        if (!values.datainicial) {
            errors.datainicial = 'Obrigatório';
        }

        if (!values.datafinal) {
            errors.datafinal = 'Obrigatório';
        }
               
        return errors;
    }

    handleDadosForm = () => {
        return [
            {
                formsessao: 'Sistema de Confência',
                rows: [
                    [
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'Não', component: 'checkbox', value: 'N' },
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'Sim', component: 'checkbox', value: 'S' },
                    ]
                ]
            },{
                formsessao: 'Sistema',
                rows: [
                    [
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'VIP', component: 'checkbox', value: 'V' },
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'FEIRA', component: 'checkbox', value: 'F' },
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'Produto de Rótulos:', component: 'checkbox', value: 'C' },
                        { md: 4, type: "radio", name: 'vernocongresso', label: 'Palestras na Feira', component: 'checkbox', value: 'Z' },
                    ]
                ]
            },{
                formsessao: 'Visualização do Produto',
                rows: [
                    [
                        { md: 4, type: "checkbox", name: 'vernoingresso', label: 'Sistema de Ingressos', component: 'checkbox', value: 'S' },
                        this.state.camposcomtraducao?
                        { md: 4, type: "checkbox", name: 'vernocongressoen', label: 'Acesso Inglês', component: 'checkbox', value: 'S' }
                        :
                        {}
                        ,
                        this.state.camposcomtraducao?
                        { md: 4, type: "checkbox", name: 'vernocongressoes', label: 'Acesso Espanhol', component: 'checkbox', value: 'S' }:{},
                    ]
                ]
            }, {
                formsessao: 'Descrição do Produto',
                rows: [
                    [
                        { md: 4, type: "text", name: 'descricaoprecos', label: 'Português', component: 'texto' },
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'descricaoprecos_en', label: 'Inglês', component: 'texto' }:{},
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'descricaoprecos_es', label: 'Espanhol', component: 'texto' }:{}
                    ], [
                        { md: 4, type: "text", name: 'descricao_credencial', label: 'Descrição para Mostrar na Credencial', component: 'texto' },
                    ]
                ]
            }, {
                formsessao: 'Texto de ajuda',
                rows: [
                    [
                        { md: 4, type: "text", name: 'descricao_portugues', label: 'Português', component: 'texto' },
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'descricao_ingles', label: 'Inglês', component: 'texto' }:{},
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'descricao_espanhol', label: 'Espanhol', component: 'texto' }:{},
                    ]
                ]
            }, {
                formsessao: 'Informações do Produto',
                rows: [
                    [
                        { md: 4, type: "text", name: 'infoproduto', label: 'Português', component: 'texto' },
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'infoprodutoingles', label: 'Inglês', component: 'texto' }:{},
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'infoprodutoespanhol', label: 'Espanhol', component: 'texto' }:{},
                    ]
                ]
            }, {
                formsessao: 'Código de Grupo do Produto',
                rows: [
                    [
                        { md: 4, type: "text", name: 'grupo', label: 'Grupo de Seleção', component: 'texto' },
                        { md: 4, type: "text", name: 'grupodesconto', label: 'Grupo de Desconto', component: 'texto' }
                    ]
                ]
            }, {
                formsessao: 'Desconto',
                rows: [
                    [
                        { md: 4, type: "text", name: 'qtdedesconto', label: 'Quantidade de Desconto', component: 'texto' }
                    ]
                ]
            }, {
                formsessao: 'Auditório',
                rows: [
                    [
                        { md: 4, type: "text", name: 'auditorio', label: 'Informe', component: 'texto' }
                    ]
                ]
            },{
                formsessao: 'Palestrante',
                rows: [
                    [
                        { md: 4, type: "textarea", name: 'palestrante', label: 'Descrição', component: 'texto', rows: 5 },
                        { md: 4, type: "text", name: 'empresapalestrante', label: 'Empresa do Palestrante', component: 'texto' }
                    ]
                ]
            },{
                formsessao: 'Datas',
                rows: [
                    [
                        { md: 4, type: "text", name: 'datainicial', label: 'Data Inicial', component: 'calendario' },
                        { md: 4, type: "text", name: 'datafinal', label: 'Data Final', component: 'calendario' },
                    ]
                ]
            }, {
                formsessao: 'Regras',
                rows: [
                    [
                        { md: 3, type: "checkbox", name: 'vernoponto', label: 'Usar no Ponto de Vendas', component: 'checkbox' },
                        { md: 3, type: "checkbox", name: 'vernocallcenter', label: 'Usar no Call Center', component: 'checkbox' }                        
                    ],[
                        { md: 3, type: "text", name: 'numerovagas', label: 'Número de Vagas', component: 'texto' },
                        { md: 3, type: "text", name: 'numerolimite', label: 'Número Limite por Pedido', component: 'texto' },
                    ], [
                        { md: 3, type: "text", name: 'cotagratuita', label: 'Cota Gratuita para VIP', component: 'texto' },
                        { md: 3, type: "text", name: 'codigo', label: 'Ordem de Mostragem', component: 'texto' },
                        { md: 3, type: "text", name: 'ordemrelatorio', label: 'Ordem de Mostragem ADM', component: 'texto' },
                        { md: 3, type: "text", name: 'quantsessao', label: 'Qtde de Escolha de Sessões', component: 'texto' },
                    ],[
                        { md: 3, type: "text", name: 'qtdeparcelas', label: 'Qtde Parcelas', component: 'texto' },
                        { md: 3, type: "text", name: 'qtdemin', label: 'Qtde Minima de Inscritos', component: 'texto' },
                        { md: 3, type: "text", name: 'qtdemax', label: 'Qtde Maxíma de Inscritos', component: 'texto' }                        
                    ]
                ]
            }, {
                formsessao: 'Texto de ajuda',
                rows: [
                    [
                        { md: 4, type: "text", name: 'imagemproduto', label: 'Imagem do Produto', component: 'upload', 
                        preimagens: getPreImagesCampo('imagemproduto',this.props.item.imagens) },
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'imagemprodutoingles', 
                        label: 'Imagem do Produto em Inglês', component: 'upload', preimagens: getPreImagesCampo('imagemprodutoingles',this.props.item.imagens) }:{},
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'imagemprodutoespanhol', 
                        label: 'Imagem do Produto em Espanhol:', component: 'upload', preimagens: getPreImagesCampo('imagemprodutoespanhol',this.props.item.imagens) }:{},
                    ], [
                        { md: 4, type: "text", name: 'credencialpdf_pt', label: 'Credencial do Produto em Portuguê', component: 'upload' },
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'credencialpdf_en', label: 'Credencial do Produto em Inglês', component: 'upload' }:{},
                        this.state.camposcomtraducao?{ md: 4, type: "text", name: 'credencialpdf_es', label: 'Credencial do Produto em Espanhol', component: 'upload' }:{},
                    ]
                ]
            }, {
                formsessao: 'Mostra nos Relatórios do ADM',
                rows: [
                    [
                        { md: 4, type: "radio", name: 'auditorio', label: 'SIM', component: 'checkbox', value: 'S' },
                        { md: 4, type: "radio", name: 'auditorio', label: 'NÃO', component: 'checkbox', value: 'N' }
                    ]
                ]
            }
        ];
    }

    render() {
        return (
            <FormCadastro
                handleSubmit={this.handleSubmit}
                handleValidacao={this.handleValidacao}
                initialValues={getCamposInitialValues(this.handleDadosForm(), this.props.item)}
                handleResetReducer={this.props.subitemzeraselecionado}
                resultcadastro={this.props.resultcadastro&&this.props.resultcadastro.idsubitems}
                handleResetAlertReducer={this.props.zeranovoatualiza}
                formcampos={[...this.handleDadosForm()]}
                btosubmitlabel="Confirmar"
            />
        );
    }
}

const mapStateToProps = (state) => {    
    return {
        itemevento: state.reducerPesquisaItem,
        item: state.reducerSubitemSelecionado,
        pendingTasks: state.pendingTasks,
        resultcadastro: state.reducerSubitemNovoAtualiza
    }
}

export default connect(mapStateToProps, { novoatualiza, subitemzeraselecionado, zeranovoatualiza })(FormProdutos);